import { Box, Tooltip } from "@mui/material"
import { Selectable } from "routes/schedule/components/selectable"
import { NumericSummary } from "routes/schedule/components/summary"
import { LocalizedMessage } from "lib/localization/localized-message"
import { ZERO_U_WORDS } from "routes/schedule/tasks/frequency"
import { useTranslationContext } from "routes/schedule/plugins/translation/use-translation-context"

function colorFromFrequency(frequency) {
    return frequency.period === "Unknown" ? "red" : "primary.main"
}

export function titleFromFrequency(frequency) {
    if (!frequency || frequency.period === "Unknown") return "0U"
    return `${frequency.interval}${frequency.period[0]}`
}

const ICONS_FROM_PERIOD = {}

function iconFrom(frequency) {
    return ICONS_FROM_PERIOD[frequency.period] ?? "ant-design:calendar-outlined"
}

export function PeriodSummary({ title, frequency, Component = Selectable, ...props }) {
    const { translatedSkills } = useTranslationContext()
    const showTitle = titleFromFrequency(frequency)

    return (
        <Component
            data-cy="schedule-summary-filter-period"
            group="period"
            {...(Component === Selectable ? { onSelected: filterForFrequency, key: showTitle } : {})}
        >
            <Tooltip title={tooltipTitle()} arrow>
                <Box>
                    <NumericSummary
                        title={title ?? titleFromFrequency(frequency)}
                        color={colorFromFrequency(frequency)}
                        icon={iconFrom(frequency)}
                        {...props}
                    />
                </Box>
            </Tooltip>
        </Component>
    )

    function filterForFrequency(item) {
        return item.frequency?.period === frequency.period && +item.frequency?.interval === +frequency.interval
    }

    function tooltipTitle() {
        if (showTitle !== "0U") return undefined
        if (translatedSkills?._zeroUTooltip) return translatedSkills._zeroUTooltip
        return <LocalizedMessage template={ZERO_U_WORDS} />
    }
}
